import React, { memo } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import axios from 'axios';
import ChatHeader from './ChatHeader';
import ChatBody from './ChatBody';
import ChatFooter from './ChatFooter';

import actions from '../../store/actions';
import { WebsocketAdapter } from '../../pages/Webchat/WebsocketAdapter';

import './index.scss';

const socketUrl = process.env.REACT_APP_SOCKET_URL || 'ws://localhost:3999';
const orchestratorUrl =
  process.env.REACT_APP_ORCHESTRATOR_URL || 'http://localhost:3334';

class Chat extends React.Component {
  client = undefined;

  constructor(props) {
    super(props);
    this.state = {
      initialized: false,
      id: '',
      socketId: '',
      messages: [],
      quickAccess: {},
      isQuickAccessOpen: false,
      isQuickAccessActive: false,
      currentBotId: undefined,
    };

    this.suggestionList = [];
  }

  initChat = () => {
    const { botId } = this.props;
    const { initialized, currentBotId } = this.state;
    if (initialized) {
      return;
    }
    this.setState({ initialized: true });

    if (!currentBotId) {
      this.setState({ currentBotId: botId });
    }

    if (!this.client) {
      this.client = new WebsocketAdapter(socketUrl);
      this.client.connect();
      this.client.onOpen(() => {
        const { id } = this.state;
        this.client.sendMessage({
          action: 'link',
          data: { sessionId: id, botId },
        });
      });
      this.client.onLink(async ({ data }) => {
        const newSocketId = data.socketId;
        this.setState({ socketId: newSocketId });

        const response = await axios.post(
          `${orchestratorUrl}/webchat/subscribe`,
          {
            sessionId: this.state.id || '',
            botId,
            socketId: this.socketId,
            isPreview: true,
            channel: 'webchat',
          }
        );

        this.setState({ id: response.data.sessionId });
      });
      this.client.onMessage((data) => {
        const { messages } = this.state;
        const updatedMessage = messages.filter((i) => i.type !== 'TYPING');
        const message = { ...data, from: 'BOT' };

        if (
          message.type === 'TYPING' ||
          message.type === 'MESSAGE' ||
          (message.type === 'TEXT' &&
            message.message &&
            message.message.trim().length > 0) ||
          (message.type === 'IMAGE' && message.image) ||
          (message.type === 'DOCUMENT' && message.document.fileUrl) ||
          (message.type === 'AUDIO' && message.audio.fileUrl) ||
          (message.type === 'VIDEO' && message.video.fileUrl) ||
          (message.type === 'CAROUSEL' && message)
        ) {
          updatedMessage.push(message);
        }
        this.setState({ messages: updatedMessage });
      });
      this.client.onEndConversation(() => {
        this.setState({
          currentBotId: botId,
          id: '',
        });
      });
    }
  };

  sendMessage = (message, type, ext, properties = {}) => {
    const { messages, id, currentBotId } = this.state;
    const { botId } = this.props;
    if (!currentBotId) {
      this.setState({ currentBotId: botId });
    }

    axios.post(`${orchestratorUrl}/webchat/message`, {
      botId,
      message,
      isMedia: ext && ext !== '',
      ext,
      sessionId: id,
      botChannel: 'WebChat',
      isPreview: true,
      socketId: this.state.socketId,
    });
    if (message && message.trim().length > 0) {
      messages.push({ from: 'USER', message, type, properties });
    }
    this.setState({ messages });
  };

  handleCarouselButtonClick = (clickInfo) => {
    const { clickedButton, clickedCard } = clickInfo;
    const { destination } = clickedButton;
    const { type, value } = destination;

    if (type === 'url') {
      window.open(value, '_blank');
    }

    if (type === 'phone') {
      window.open(`tel:${value}`, '_blank');
    }

    const { id, currentBotId } = this.state;
    const { botId } = this.props;
    if (!currentBotId) {
      this.setState({ currentBotId: botId });
    }

    axios.post(`${orchestratorUrl}/webchat/action`, {
      botId: currentBotId || botId,
      action: { type: 'CAROUSEL', data: { clickedButton, clickedCard } },
      sessionId: id,
    });
  };

  resetPreview = () => {
    if (this.client) {
      this.client.disconnect();
      this.client = null;
    }
    const { botId } = this.props;
    this.setState({
      initialized: false,
      id: '',
      messages: [],
      currentBotId: botId,
    });
  };

  closeConnection = () => {
    if (this.client) {
      this.client.disconnect();
      this.client = undefined;
    }
  };

  getClosePreviewChat = () => {
    const { closePreviewChat } = this.props;

    if (closePreviewChat) {
      closePreviewChat();
    }
  };

  handleSendQuickAccessItemId = (props) => {
    const { itemId, title } = props;
    axios.post(`${orchestratorUrl}/webchat/quick-access`, {
      sessionId: this.state.id,
      botId: this.props.botId,
      itemId,
      name: title,
      isPreview: true,
    });
  };

  handleQuickAccessButtonClick = () => {
    const listRule = {
      manual: 'manualList',
      lastday: 'lasdayList',
      lastweek: 'lastweekList',
      lastmonth: 'lastmonthList',
    };

    const { quickAccess } = this.state;

    if (quickAccess && quickAccess.quickAccessActive) {
      const rule = quickAccess.sortingRules;
      const theRule = listRule[rule];
      if (
        rule !== '' &&
        quickAccess[theRule] &&
        quickAccess[theRule].length > 0
      ) {
        // eslint-disable-next-line react/no-access-state-in-setstate
        this.setState({ isQuickAccessOpen: !this.state.isQuickAccessOpen });
      }
    }
  };

  handleQuickAccessClose = () => {
    const listRule = {
      manual: 'manualList',
      lastday: 'lasdayList',
      lastweek: 'lastweekList',
      lastmonth: 'lastmonthList',
    };

    const { quickAccess } = this.state;

    if (quickAccess && quickAccess.quickAccessActive) {
      const rule = quickAccess.sortingRules;
      const theRule = listRule[rule];
      if (
        rule !== '' &&
        quickAccess[theRule] &&
        quickAccess[theRule].length > 0
      ) {
        // eslint-disable-next-line react/no-access-state-in-setstate
        this.setState({ isQuickAccessOpen: false });
      }
    }
  };

  render() {
    const { title, firstTest, startTest } = this.props;
    const { messages } = this.state;
    this.initChat();
    if (firstTest) {
      return (
        <div className="chat-box">
          <ChatHeader
            title={title}
            closeConnection={() => this.closeConnection()}
            closePreviewChat={() => this.getClosePreviewChat()}
          />
          <ChatBody
            firstTest={firstTest}
            messages={messages}
            startTest={startTest}
          />
        </div>
      );
    }

    return (
      <div className="chat-box">
        <ChatHeader
          title={title}
          resetPreview={this.resetPreview}
          closeConnection={() => this.closeConnection()}
          closePreviewChat={() => this.getClosePreviewChat()}
        />
        <div className="container-bot-messages">
          <ChatBody
            messages={messages}
            startTest={startTest}
            handleCarouselButtonClick={(clickInfo) =>
              this.handleCarouselButtonClick(clickInfo)
            }
            sendMessage={this.sendMessage}
            quickAccess={this.state.quickAccess}
            handleSendId={this.handleSendQuickAccessItemId}
            isQuickAccessOpen={this.state.isQuickAccessOpen}
            handleCloseQuickAccess={this.handleQuickAccessButtonClick}
          />
        </div>
        <ChatFooter
          sendMessage={this.sendMessage}
          isQuickAccessActive={this.state.isQuickAccessActive}
          isQuickAccessOpen={this.state.isQuickAccessOpen}
          handleToggleQuickAccess={this.handleQuickAccessButtonClick}
          handleQuickAccessClose={this.handleQuickAccessClose}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  firstTest: state.previewBot.firstTest,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actions.previewBot, dispatch);

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(memo(Chat));
